import type { AccountAddress } from "@/types";

type AccountAddressLike = Pick<
  AccountAddress,
  "addressLine" | "wardName" | "cityName"
>;

export const formatAccountAddress = (address: AccountAddressLike) =>
  [address.addressLine, address.wardName, address.cityName]
    .filter(Boolean)
    .join(", ");
